import { IRootState } from '../../../../../store'
import { IObstetricsState } from '../store/obstetrics.types'

export const getObstetricsSelector = (state: IRootState): IObstetricsState => state.obstetrics
